import React from "react";
import styles from "./Search.module.sass";

const Search = () => {
	return <div>Search</div>;
};

export default Search;
